module.exports = __webpack_public_path__ + "img/img-b880f637.04638009.png";